module.exports = __webpack_public_path__ + "static/algebraic-ktheory-and-its-applications-5626799bf72860a2c24d4e02db761cf0.jpg";